export const storageNames = {
  localUserInfo: "user_info",
  localAuthData: "auth_data",
  localExpAuthData: "[exp]:auth_data",
  sessionUserInfo: "user_info",
  sessionAuthData: "auth_data"
};
